<template>
  <b-modal
    content-class="mymodalContent"
    modal-class="mymodal"
    id="addThemeElement"
    centered
    hide-header
    hide-footer
    @show="onShow"
    @hide="onHide"
  >
    <div class="modal-div">
      <h2 v-html="title"></h2>

      <span v-if="displayAbbrError" class="warning-msg">
        <alert-icon title="" />
        <p
          class="my-p"
          v-html="$t('components.popinAddElement.addTheme.error')"
        ></p>
      </span>

      <b-form-textarea
        v-show="
          params.type == 'ADD-DESCRIPTION_SITUATION_ELEMENT' ||
            params.type == 'ADD-OBJECTIFICATION_ELEMENT' ||
            params.type == 'EDIT-DESCRIPTION_SITUATION_ELEMENT' ||
            params.type == 'EDIT-OBJECTIFICATION_ELEMENT'
        "
        id="textarea"
        v-model="newInput"
        rows="2"
        max-rows="7"
        :no-auto-shrink="true"
        maxlength="1000"
        ref="areaInput"
        class="myinput"
        :placeholder="placeholder"
      ></b-form-textarea>

      <b-form-input
        v-show="
          params.type == 'NEW-SUBTHEME' || params.type == 'RENAME-SUBTHEME'
        "
        ref="normalInput"
        v-model="newInput"
        :placeholder="placeholder"
        class="myinput"
        v-on:keyup.enter="validate()"
        maxlength="150"
      ></b-form-input>

      <b-form-group
        v-show="params.type == 'RENAME-THEME' || params.type == 'ADD-THEME'"
        :label="$t('components.popinAddElement.addTheme.labelAbbr')"
      >
        <b-form-input
          class="abbr-input myinput"
          ref="abbrInput"
          v-model="newInputObj.abbr"
          maxlength="13"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        v-if="params.type == 'RENAME-THEME' || params.type == 'ADD-THEME'"
        :label="$t('components.popinAddElement.addTheme.labelTitle')"
      >
        <b-form-input
          :placeholder="placeholder"
          v-on:keyup.enter="validate()"
          v-model="newInputObj.title"
          class="myinput"
          maxlength="75"
        ></b-form-input>
      </b-form-group>

      <div class="popin-actions">
        <b-button class="popin-btn-cancel" @click="closeModal()">
          <cancel-icon title="" />{{
            $t("components.popinAddElement.btns.cancel")
          }}
        </b-button>
        <b-button
          class="refonte_btn-primary popin-btn-confirm"
          :disabled="disabled"
          @click="validate()"
        >
          <check-icon title="" />{{
            $t("components.popinAddElement.btns.confirm")
          }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import AlertIcon from "vue-material-design-icons/Alert.vue";
import CancelIcon from "vue-material-design-icons/Cancel.vue";
import CheckIcon from "vue-material-design-icons/Check.vue";

export default {
  name: "addThemeElement",
  components: {
    AlertIcon,
    CancelIcon,
    CheckIcon
  },
  computed: {
    themes: function() {
      return this.$store.state.gpsstModule.gpsst.themes;
    },
    params: function() {
      return this.$store.state.appState.popinParams;
    },
    // active le bouton de validation si le champ est non vide
    disabled: function() {
      if (
        this.params.type !== "RENAME-THEME" &&
        this.params.type !== "ADD-THEME"
      ) {
        if (this.newInput == "") return true;
        else return false;
      } else {
        if (!this.newInputObj.abbr || !this.newInputObj.title) {
          return true;
        } else return false;
      }
    }
  },
  watch: {
    params: async function() {
      var that = this;
      // on met le focus sur la zone de saisie
      if (
        this.params.type == "ADD-DESCRIPTION_SITUATION_ELEMENT" ||
        this.params.type == "ADD-OBJECTIFICATION_ELEMENT" ||
        this.params.type == "EDIT-DESCRIPTION_SITUATION_ELEMENT" ||
        this.params.type == "EDIT-OBJECTIFICATION_ELEMENT"
      ) {
        if (this.params.type == "ADD-DESCRIPTION_SITUATION_ELEMENT") {
          this.title = this.$i18n.t(
            "components.popinAddElement.addObservation.title"
          );
          this.placeholder = this.$i18n.t(
            "components.popinAddElement.addObservation.placeholder"
          );
        }
        if (this.params.type == "ADD-OBJECTIFICATION_ELEMENT") {
          this.title = this.$i18n.t(
            "components.popinAddElement.objectification.title"
          );
          this.placeholder = this.$i18n.t(
            "components.popinAddElement.objectification.placeholder"
          );
        }
        if (this.params.type == "EDIT-DESCRIPTION_SITUATION_ELEMENT")
          this.title = this.$i18n.t(
            "components.popinAddElement.editObservation.title"
          );
        if (this.params.type == "EDIT-OBJECTIFICATION_ELEMENT")
          this.title = this.$i18n.t(
            "components.popinAddElement.editObjectification.title"
          );

        // nextTick permet d'attendre que la variable $ref soit à jour
        await this.$nextTick();
        // setTimeout function adds a task to the queue which is executed after a given interval, while .focus() is not added to any queue for execution.
        //So, in case of setTimeout, a gap of milliseconds might be enough to perform the above said task
        // le focus ne se met pas en place sans le setTiemout sur Chrome (mini 0 au setTimeout) et IE (mini 50 au setTimeout)
        setTimeout(function() {
          that.$refs.areaInput.$el.focus();
        }, 250);
      }
      if (
        this.params.type == "NEW-SUBTHEME" ||
        this.params.type == "RENAME-SUBTHEME"
      ) {
        if (this.params.type == "NEW-SUBTHEME") {
          this.title = this.$i18n.t(
            "components.popinAddElement.subtheme.title"
          );
          this.placeholder = this.$i18n.t(
            "components.popinAddElement.subtheme.placeholder"
          );
        }
        if (this.params.type == "RENAME-SUBTHEME")
          this.title = this.$i18n.t(
            "components.popinAddElement.renameSubTheme.title"
          );

        await this.$nextTick();
        setTimeout(function() {
          that.$refs.normalInput.$el.focus();
        }, 250);
      }
      if (
        this.params.type == "EDIT-DESCRIPTION_SITUATION_ELEMENT" ||
        this.params.type == "EDIT-OBJECTIFICATION_ELEMENT" ||
        this.params.type == "RENAME-SUBTHEME"
      ) {
        this.newInput = this.params.description;
      }
      if (
        this.params.type == "RENAME-THEME" ||
        this.params.type == "ADD-THEME"
      ) {
        if (this.params.type == "ADD-THEME") {
          this.title = this.$i18n.t(
            "components.popinAddElement.addTheme.title"
          );
          this.placeholder = this.$i18n.t(
            "components.popinAddElement.addTheme.placeholder"
          );
        }
        if (this.params.type == "RENAME-THEME")
          this.title = this.$i18n.t(
            "components.popinAddElement.renameTheme.title"
          );

        this.newInputObj = {
          abbr: this.params.abbr,
          title: this.params.title
        };
        await this.$nextTick();
        setTimeout(function() {
          that.$refs.abbrInput.$el.focus();
        }, 250);
      }
    }
  },
  data: function() {
    return {
      displayAbbrError: false,
      title: null,
      placeholder: null,
      newInput: "",
      newInputObj: {
        abbr: "",
        title: ""
      }
    };
  },
  methods: {
    /**
     * Callback appelée juste avant l'affichage de la modale
     * @param bvModalEvt - Objet BvModalEvent
     */
    onShow: function(bvModalEvt) { //eslint-disable-line no-unused-vars
      this.displayAbbrError = false;
      this.newInput = "";
      this.newInputObj = {
        abbr: "",
        title: ""
      };
    },
    /**
     * Callback appelée juste avant le masquage de la modale
     * @param bvModalEvt - Objet BvModalEvent
     */
    onHide: function(bvModalEvt) { //eslint-disable-line no-unused-vars
    },
    
    closeModal: function() {
      this.newInput = "";
      this.displayAbbrError = false;
      this.$bvModal.hide("addThemeElement");
    },
    validate: function() {
      var newData = {};
      if (this.params.type == "ADD-DESCRIPTION_SITUATION_ELEMENT") {
        newData = {
          type: this.params.type,
          params: {
            themeAbbr: this.params.themeAbbr,
            subThemeRef: this.params.subThemeRef,
            sliceRef: this.params.slice.ref,
            description: this.newInput,
            custom: true,
            style: ""
          }
        };
      }
      if (this.params.type == "ADD-OBJECTIFICATION_ELEMENT") {
        newData = {
          type: this.params.type,
          params: {
            themeAbbr: this.params.themeAbbr,
            sliceRef: this.params.slice.ref,
            description: this.newInput
          }
        };
      }
      var abbrAlreadyUsed = false;
      if (this.params.type == "EDIT-DESCRIPTION_SITUATION_ELEMENT") {
        newData = {
          type: this.params.type,
          params: {
            themeAbbr: this.params.themeAbbr,
            subThemeRef: this.params.subThemeRef,
            descriptionRef: this.params.descriptionRef,
            description: this.newInput
          }
        };
      }
      if (this.params.type == "EDIT-OBJECTIFICATION_ELEMENT") {
        newData = {
          type: this.params.type,
          params: {
            themeAbbr: this.params.themeAbbr,
            objectificationRef: this.params.objectificationRef,
            description: this.newInput
          }
        };
      }
      if (this.params.type == "NEW-SUBTHEME") {
        newData = {
          type: this.params.type,
          params: {
            themeAbbr: this.params.themeAbbr,
            custom: true,
            description: this.newInput
          }
        };
      }
      if (this.params.type == "RENAME-SUBTHEME") {
        newData = {
          type: this.params.type,
          params: {
            themeAbbr: this.params.themeAbbr,
            subThemeRef: this.params.subThemeRef,
            description: this.newInput
          }
        };
      }
      if (
        this.params.type == "RENAME-THEME" ||
        this.params.type == "ADD-THEME"
      ) {
        newData = {
          type: this.params.type,
          params: {
            themeAbbr: this.params.themeAbbr,
            title: this.newInputObj.title,
            abbr: this.newInputObj.abbr
          }
        };
        // on vérifie que l'abbréviation soit unique
        for (let theme in this.themes) {
          if (
            this.themes[theme].abbreviation == this.newInputObj.abbr &&
            this.themes[theme].ref !== this.params.themeRef
          ) {
            abbrAlreadyUsed = true;
          }
        }
      }

      if (
        (this.params.type == "RENAME-THEME" ||
          this.params.type == "ADD-THEME") &&
        abbrAlreadyUsed
      ) {
        this.displayAbbrError = true;
      } else {
        if (this.params.type != "ADD-THEME") {
          this.$store.dispatch("editThemeElement", newData);
        }
        if (this.params.type == "ADD-THEME") {
          this.$store.dispatch("addTheme", this.newInputObj);
        }
        this.newInput = "";
        this.newInputObj = { abbr: "", title: "" };
        this.$bvModal.hide("addThemeElement");
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.refonte_btn-primary[disabled]
  pointer-events: none

.abbr-input
  width: 8em
</style>

